import { createExternalRouteRef } from '@backstage/core-plugin-api';

export const workflowsRouteRef = createExternalRouteRef({
  id: 'workflows',
});

export const workflowRouteRef = createExternalRouteRef({
  id: 'workflow',
  params: ['workflow'],
});

export const workflowInstanceRouteRef = createExternalRouteRef({
  id: 'workflowInstance',
  params: ['workflow', 'id'],
});
